import {TopBannerImageDefaultBox} from "./top-banner-image.default.box";

export const TopBannerImageBox = TopBannerImageDefaultBox;